module.exports = __webpack_public_path__ + "img/light-home.b9ac1636.svg";